const ALLOWED_PROTOCOLS = ["http://", "https://"];
const BLOCKED_PROTOCOLS = ["ftp://", "file://", "mailto:", "tel:", "data:"];
const BLOCKED_HOSTS = ["localhost"];

export function validateUrl(raw: string): string | null {
  const input = raw.trim().toLowerCase();

  if (!input) return "Please enter a website URL.";
  if (/\s/.test(input)) return "URL cannot contain spaces.";

  // Protocol check
  const hasProtocol = /^[a-z][a-z0-9+.-]*:\/\//i.test(input);
  if (hasProtocol) {
    if (BLOCKED_PROTOCOLS.some((p) => input.startsWith(p)))
      return "Only http:// and https:// protocols are allowed.";
    if (!ALLOWED_PROTOCOLS.some((p) => input.startsWith(p)))
      return "Only http:// and https:// protocols are allowed.";
  }

  // Strip protocol for domain checks
  const domain = input.replace(/^https?:\/\//, "");
  if (!domain) return "Please enter a domain name after the protocol.";

  // Blocked hosts
  if (BLOCKED_HOSTS.includes(domain)) return "localhost is not allowed.";

  // IP address check
  if (/^\d{1,3}(\.\d{1,3}){3}$/.test(domain)) return "IP addresses are not allowed. Please enter a domain name.";

  // Must contain at least one dot
  if (!domain.includes(".")) return "Enter a full domain (e.g. example.com).";

  // No leading/trailing dots
  if (domain.startsWith(".")) return "Domain cannot start with a dot.";
  if (domain.endsWith(".")) return "Domain cannot end with a dot.";

  // No consecutive dots
  if (domain.includes("..")) return "Domain cannot have consecutive dots.";

  // Allowed characters (letters, numbers, hyphens, dots)
  if (!/^[a-z0-9.-]+$/.test(domain))
    return "Only letters, numbers, hyphens, and dots are allowed.";

  // Label rules
  const labels = domain.split(".");
  for (const label of labels) {
    if (!label) return "Domain has an empty label.";
    if (label.length > 63) return `"${label}" exceeds 63 characters.`;
    if (label.startsWith("-")) return "Domain labels cannot start with a hyphen.";
    if (label.endsWith("-")) return "Domain labels cannot end with a hyphen.";
  }

  // TLD check — at least 2 characters
  const tld = labels[labels.length - 1];
  if (tld.length < 2) return "Top-level domain must be at least 2 characters (e.g. .com, .io).";

  // Full length
  if (domain.length > 253) return "Domain is too long (max 253 characters).";

  return null; // valid
}
